import React, { useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'

// Import Libraries
import { Helmet } from 'react-helmet'
import {
  FaPen,
  FaTrash,
  FaRegCalendarCheck,
  FaUserTie,
  FaCog,
  FaEnvelope,
  FaPhoneAlt,
  FaLinkedin,
  FaGithub,
} from 'react-icons/fa'

// Import Components
import Screen from '../../components/accounts/Screen'
import PageTitle from '../../components/accounts/PageTitle'
import ProfileExperienceModal from '../../components/accounts/modals/ProfileExperienceModal'
import ProfileAvailabilityModal from '../../components/accounts/modals/ProfileAvailabilityModal'
import ProfileRoleSalaryModal from '../../components/accounts/modals/ProfileRoleSalaryModal'
import ProfileEducationModal from '../../components/accounts/modals/ProfileEducationModal'
import ProfileInfoModal from '../../components/accounts/modals/ProfileInfoModal'

const Profile = () => {
  const [experienceModalShow, setExperienceModalShow] = useState(false)
  const [availabilityModalShow, setAvailabilityModalShow] = useState(false)
  const [roleSalaryModalShow, setRoleSalaryModalShow] = useState(false)
  const [educationModalShow, setEducationModalShow] = useState(false)
  const [infoModalShow, setInfoModalShow] = useState(false)

  return (
    <Screen>
      <Helmet>
        <title>Profile</title>
      </Helmet>
      <PageTitle title='Profile' />
      <Container fluid className='p-0 my-profile'>
        <section className='my-profile-section mt-5'>
          <Row>
            <Col md={6}>
              <Row>
                <Col md={8}>
                  <h5>John Doe</h5>
                  <p className='detail'>Ready to start from next week</p>
                </Col>
                <Col md={4}>
                  <FaPen
                    className='icon'
                    onClick={() => setInfoModalShow(true)}
                  />
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col md={4} style={{ textAlign: 'left' }}>
                  <FaEnvelope /> demo@example.com
                </Col>
                <Col md={4} style={{ textAlign: 'left' }}>
                  <FaPhoneAlt /> +9225574555
                </Col>
                <Col md={4}>
                  <FaLinkedin /> &nbsp;&nbsp;&nbsp; <FaGithub />
                </Col>
              </Row>
              <hr />
            </Col>
          </Row>
        </section>

        <section className='my-profile-section mt-3'>
          <Row>
            <Col md={6}>
              <h5>
                <FaCog style={{ marginRight: '10px', fontSize: '18px' }} />{' '}
                Overall experience
              </h5>
              <div className='mt-4'>
                <Row>
                  <Col md={8}>
                    <h6>4 years/ 2 years remote</h6>
                    <p className='detail'>Basic English proficiency</p>
                  </Col>
                  <Col md={4}>
                    <FaPen
                      className='icon'
                      onClick={() => setExperienceModalShow(true)}
                    />
                  </Col>
                </Row>
              </div>
              <hr />
            </Col>
          </Row>
        </section>

        <section className='my-profile-section mt-3'>
          <Row>
            <Col md={6}>
              <h5>
                <FaRegCalendarCheck
                  style={{ marginRight: '10px', fontSize: '18px' }}
                />{' '}
                Availability
              </h5>
              <div className='mt-4'>
                <Row>
                  <Col md={8}>
                    <h6>Full Time</h6>
                    <p className='detail'>Ready to start from next week</p>
                  </Col>
                  <Col md={4}>
                    <FaPen
                      className='icon'
                      onClick={() => setAvailabilityModalShow(true)}
                    />
                  </Col>
                </Row>
              </div>
              <hr />
            </Col>
          </Row>
        </section>

        <section className='my-profile-section mt-3'>
          <Row>
            <Col md={6}>
              <h5>
                <FaUserTie style={{ marginRight: '10px', fontSize: '18px' }} />{' '}
                Role and current salary
              </h5>
              <div className='mt-4'>
                <Row>
                  <Col md={8}>
                    <h6>Fullstack (BE-heavy)</h6>
                    <p className='detail'>80,000 PKR / Year</p>
                  </Col>
                  <Col md={4}>
                    <FaPen
                      className='icon'
                      onClick={() => setRoleSalaryModalShow(true)}
                    />
                  </Col>
                </Row>
              </div>
              <hr />
            </Col>
          </Row>
        </section>

        <section className='my-profile-section mt-3'>
          <Row>
            <Col md={6}>
              <h5>Education</h5>
              <div className='mt-4'>
                <Row className='mb-2'>
                  <Col md={8}>
                    <p className='detail mb-2'>March 2020 - March 2021</p>
                    <h6>Masters</h6>
                    <p className='detail'>GCUF</p>
                  </Col>
                  <Col md={4}>
                    <FaPen className='icon' />
                    <FaTrash className='icon' />
                  </Col>
                </Row>

                <Row className='mb-2'>
                  <Col md={8}>
                    <p className='detail mb-2'>March 2020 - March 2021</p>
                    <h6>Masters</h6>
                    <p className='detail'>GCUF</p>
                  </Col>
                  <Col md={4}>
                    <FaPen className='icon' />
                    <FaTrash className='icon' />
                  </Col>
                </Row>

                <Row className='mb-2'>
                  <Col md={8}>
                    <p className='detail mb-2'>March 2020 - March 2021</p>
                    <h6>Masters</h6>
                    <p className='detail'>GCUF</p>
                  </Col>
                  <Col md={4}>
                    <FaPen className='icon' />
                    <FaTrash className='icon' />
                  </Col>
                </Row>

                <Row className='mb-2'>
                  <Col md={8}>
                    <p className='detail mb-2'>March 2020 - March 2021</p>
                    <h6>Masters</h6>
                    <p className='detail'>GCUF</p>
                  </Col>
                  <Col md={4}>
                    <FaPen className='icon' />
                    <FaTrash className='icon' />
                  </Col>
                </Row>

                <Row className='mb-2'>
                  <Col md={12}>
                    <Button
                      variant='primary'
                      onClick={() => setEducationModalShow(true)}
                    >
                      Add Education
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </section>

        <ProfileExperienceModal
          show={experienceModalShow}
          onHide={() => setExperienceModalShow(false)}
        />

        <ProfileAvailabilityModal
          show={availabilityModalShow}
          onHide={() => setAvailabilityModalShow(false)}
        />

        <ProfileRoleSalaryModal
          show={roleSalaryModalShow}
          onHide={() => setRoleSalaryModalShow(false)}
        />

        <ProfileEducationModal
          show={educationModalShow}
          onHide={() => setEducationModalShow(false)}
        />

        <ProfileInfoModal
          show={infoModalShow}
          onHide={() => setInfoModalShow(false)}
        />
      </Container>
    </Screen>
  )
}

export default Profile
